module.exports = __webpack_public_path__ + "img/btn_noti_checked.2473d9f4.svg";